import React, { useContext } from 'react';
import Select from 'react-select';
import get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import { updateVulnTemplate } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectVulnTemplateDetail, selectVulnTemplatePermissions } from 'store/KnowledgeBase/selectors';
import { basicSelect } from 'Common/styles/style';
import { capitalize } from 'utils/stringUtils';
import { easeOfResolution } from 'Screens/Constants';
import Wrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ActionBar/components/EaseOfResolutionPicker/styled';
import { selectReadOnly } from 'store/Faraday/selectors';
import { ThemeContext } from 'Context';

const EaseOfResolutionPicker = () => {
  const dispatch = useDispatch();
  const vulnTemplate = useSelector(selectVulnTemplateDetail);
  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectVulnTemplatePermissions);
  const id = get(vulnTemplate, '_id', 0);
  const vulnTemplateEaseOfResolution = get(vulnTemplate, 'easeofresolution', '');
  const value = {
    label: capitalize(vulnTemplateEaseOfResolution) || 'Ease of resolution',
    value: vulnTemplateEaseOfResolution || 'Ease of resolution'
  };

  const { themeStyles } = useContext(ThemeContext);

  return (
    <Wrapper isDisabled={ readOnly || !permissions?.update?.allowed }>
      <Select
        styles={ basicSelect(themeStyles) }
        isSearchable={ false }
        isDisabled={ readOnly || !permissions?.update?.allowed }
        value={ value }
        onChange={ (e) => dispatch(updateVulnTemplate(id, { easeofresolution: e.value })) }
        options={ easeOfResolution.map((element) => ({ label: element.desc, value: element.name })) }
      />
    </Wrapper>
  );
};

export default EaseOfResolutionPicker;
